import { ArcPresenceState, IArcPresenceEntry } from '../../helpers/arcPresence/arcPresenceStore'
import { useArcPlaceholder } from '../../hooks/useArcPresence'
import Icon from '../Common/Icon'
import styles from './ArcPresence.module.scss'

const STATE_LABELS: Partial<Record<ArcPresenceState, string>> = {
  [ArcPresenceState.Working]: 'Arc is adding this…',
  [ArcPresenceState.Done]: 'Added',
  [ArcPresenceState.NeedsApproval]: 'Needs your OK in the chat',
}

const ArcTaskPlaceholder = ({ entry }: { entry: IArcPresenceEntry }) => {
  useArcPlaceholder(entry.id)
  return (
    <li className={styles.placeholder} data-cy="arc-task-placeholder">
      <span className={styles.placeholderMark}>
        <Icon name="sparkles" size="sm" />
      </span>
      <span className={styles.placeholderTitle}>
        <span className={styles.placeholderTyping}>{entry.label ?? 'New task'}</span>
      </span>
      <span className={styles.placeholderState}>{STATE_LABELS[entry.state]}</span>
    </li>
  )
}

/** The tasks Arc is making for this list, in place before they exist. */
const ArcTaskPlaceholders = ({ entries }: { entries: IArcPresenceEntry[] }) =>
  entries.length > 0 ? (
    <ul className={styles.placeholderList} aria-live="polite" aria-label="Tasks Arc is adding">
      {entries.map((entry) => (
        <ArcTaskPlaceholder key={entry.id} entry={entry} />
      ))}
    </ul>
  ) : null

export default ArcTaskPlaceholders
